import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormFreeTextField } from '@grupo-constant/next-dtype/form';
import { SECTION_COLUMN_URI, SUBSECTION_COLUMN_URI } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'freetext-field-component',
    templateUrl: './freetext-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeFreetextFieldComponent implements DTypeFormFieldComponent {

    @Input() field: DTypeFormFreeTextField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    sectionUri = SECTION_COLUMN_URI;
    subsectionUri = SUBSECTION_COLUMN_URI;

    constructor() { }

}
